<template>
  <div>
    <vxe-grid
      ref="docTable"
      :data="tableData"
      :columns="tableColumns"
      auto-resize
      highlight-hover-row
      border
      size="mini"
    >
      <template v-slot:showItem="{ row }">
        <span>
          {{ row.remark }}
        </span>
        <br />
        <span>
          {{ row.fileName }}
        </span>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_downloada') || '下载'"
            placement="top"
          >
            <i class="el-icon-download tool-btn" @click="downloadFile(row)"></i>
          </el-tooltip>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data mt-2">
            {{ $l('INDEX.table_label_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import tableColumns from './table-columns'
export default {
  props: {
    tableData: { type: Array, default: () => [] }
  },
  data() {
    return {
      tableColumns: tableColumns(this)
    }
  },
  methods: {
    downloadFile({ fileCode = '' }) {
      this.$api.SYS_FILEDOWNLOAD(fileCode)
    }
  }
}
</script>
